import { render, staticRenderFns } from "./Illustration.vue?vue&type=template&id=498271b3&"
import script from "./Illustration.vue?vue&type=script&lang=js&"
export * from "./Illustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports